import * as _4 from 'lodash4';
import { SchedulerModel } from '../../../course_scheduler/models/scheduler_model';
import { ICommand } from 'core-ts-types';
import { TermScheduleFlags } from '../../../course_scheduler/services/term_schedule_flags';
import { RegistrationAlertsServant } from '../../../course_scheduler/servants/registration_alerts_servant';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { HideRegistrationPreCheckAlertCommand } from './commands/hide_registration_pre_check_alert_command';
import { ShowRegistrationPreCheckAlertCommand } from './commands/show_registration_pre_check_alert_command';
import { RegistrationPreCheckAlertQuery } from './queries/show_registration_pre_check_alert_query';
import { TogglePendingRegistrationPreCheckAlertCommand } from './commands/toggle_pending_registration_pre_check_alert_command';
import { ToggleRefreshRegistrationPreCheckAlertCommand } from './commands/toggle_refresh_registration_pre_check_alert_command';
import { SetPreRegCheckMessageAlertCommand } from './commands/set_pre_reg_check_message_alert_command';
const Autolinker = require('autolinker');

interface IPreCheckPusherResponse {
  is_approved: boolean;
  message: string;
}

interface IRegCheckResponse {
  is_approved: boolean;
  pending_checks: any[];
}

class RegistrationPreCheck {
  private termId: number;
  private showPending: boolean = false;
  private showRefresh: boolean = false;
  private preRegistrationCheckMessage: string = '';
  private isOneClickRegistrationEnabled: boolean = false;
  constructor(
    private ngTermScheduleFlags: TermScheduleFlags,
    private getRegistrationCheckCommand: ICommand,
    private ngSchedulerModel: SchedulerModel,
    private pusherService: any,
    private $timeout: ng.ITimeoutService,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private showRegistrationPreCheckAlertCommand: ShowRegistrationPreCheckAlertCommand,
    private hideRegistrationPreCheckAlertCommand: HideRegistrationPreCheckAlertCommand,
    private togglePendingRegistrationPreCheckAlertCommand: TogglePendingRegistrationPreCheckAlertCommand,
    private toggleRefreshRegistrationPreCheckAlertCommand: ToggleRefreshRegistrationPreCheckAlertCommand,
    private setPreRegCheckMessageAlertCommand: SetPreRegCheckMessageAlertCommand,
    private ngRegistrationPreCheckAlertQuery: RegistrationPreCheckAlertQuery,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}
  $onInit() {
    this.isOneClickRegistrationEnabled = this.ngTermScheduleFlags.isOneClickRegistrationEnabled();
    if (this.isOneClickRegistrationEnabled) {
      this.hideRegistrationPreCheckAlertCommand();
      this.togglePendingRegistrationPreCheckAlertCommand(true);
      this.pusherService.waitForSubScription(this.ngSchedulerModel.read().channel_name, () => {
        this.hideRegistrationPreCheckAlertCommand();
        this.preRegistrationCheck();
      });
    } else {
      this.toggleRefreshPending(false);
    }
  }

  toggleRefreshPending(flag: boolean) {
    this.toggleRefreshButton(flag);
    this.togglePendingRegistrationPreCheckAlertCommand(flag);
  }
  stopRefreshPending() {
    this.togglePendingRegistrationPreCheckAlertCommand(false);
  }
  toggleRefreshButton(flag: boolean) {
    this.toggleRefreshRegistrationPreCheckAlertCommand(flag);
  }

  showRegistrationMessage(pusherResponse: IPreCheckPusherResponse) {
    this.$timeout(() => {
      this.stopRefreshPending();
      const preRegistrationCheckMessage = !pusherResponse.is_approved
        ? Autolinker.link(pusherResponse.message, {
            newWindow: true,
            stripPrefix: true,
            truncate: 30,
            className: 'text-link'
          })
        : ``;
      this.setPreRegCheckMessageAlertCommand(preRegistrationCheckMessage);
      this.toggleRefreshButton(!pusherResponse.is_approved);
      !pusherResponse.is_approved
        ? this.showRegistrationPreCheckAlertCommand()
        : this.hideRegistrationPreCheckAlertCommand();

      if (pusherResponse.is_approved) {
        this.emitPreCheckSuccess();
      } else {
        this.emitPreCheckFail();
      }
    });
  }

  emitPreCheckFail() {
    this.ngSchedulerModel.write({ precheck_pass: false });
    this.ngComponentCommunicatorService.publish('REGISRATION_PRE_CHECK_FAIL');
  }

  emitPreCheckSuccess() {
    this.ngSchedulerModel.write({ precheck_pass: true });
    this.ngComponentCommunicatorService.publish('REGISRATION_PRE_CHECK_SUCCESS');
  }

  preRegistrationCheck() {
    let refreshTimer: any;
    let registrationPreCheckCompleted = false;
    this.toggleRefreshPending(true);
    this.pusherService.bindToPusherEvent(
      this.ngSchedulerModel.read().channel_name,
      'registration_pre_check',
      (pusherResponse: IPreCheckPusherResponse) => {
        this.showRegistrationMessage(pusherResponse);
        registrationPreCheckCompleted = true;
        this.toggleRefreshPending(false);
        if (refreshTimer) {
          this.$timeout.cancel(refreshTimer);
        }
      }
    );
    this.getRegistrationCheckCommand(this.termId)
      .then((rsp: IRegCheckResponse) => {
        this.toggleRefreshPending(!rsp.is_approved);
        if (rsp.is_approved) {
          this.emitPreCheckSuccess();
        }
        if (!rsp.is_approved && !registrationPreCheckCompleted) {
          const REFRESH_TIMEOUT = 15000;
          refreshTimer = this.$timeout(() => {
            this.stopRefreshPending();
            this.toggleRefreshButton(true);
            this.ngRegistrationAlertsServant.createGenericNotification(
              'Unable to verify your status for registration, please refresh to try again.',
              'warn'
            );
          }, REFRESH_TIMEOUT);
        }
      })
      .catch((e) => {
        this.ngRegistrationAlertsServant.createGenericNotification(
          'Unable to verify your status for registration, please try again later.',
          'error'
        );
        this.stopRefreshPending();
      });
  }
}

class RegistrationPreCheckComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      termId: '<'
    };
    this.controller = RegistrationPreCheck;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_pre_check/registration_pre_check.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationPreCheck', new RegistrationPreCheckComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pre_check/registration_pre_check.ts